export enum TestStatus {
  Passed,
  Failed,
  Skipped,
}
